export default "__VITE_ASSET__3afa48c0__"